export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_CUSTOMER_CARE = 'ROLE_CUSTOMER_CARE'
export const ROLE_CUSTOMER_SERVICE = 'ROLE_CUSTOMER_SERVICE'
export const ROLE_WAREHOUSE = 'ROLE_WAREHOUSE'
export const ROLE_USER = 'ROLE_USER'
